// src/features/project-intake/utils/intakeHelpers.ts

import { LightboxType, ProjectIntakeForm } from '../types';

// Detect file type from URL extension
export function getFileTypeFromUrl(url: string): LightboxType {
  const lowerUrl = url.toLowerCase();
  if (/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(lowerUrl)) return 'image';
  if (/\.pdf$/i.test(lowerUrl)) return 'pdf';
  if (/\.(mp4|webm|ogg|mov|avi)$/i.test(lowerUrl)) return 'video';
  return 'doc';
}

// Check if form can be submitted based on validation rules
export function canSubmitForm(
  form: ProjectIntakeForm,
  requiresResearch: boolean,
  requiresBasic: boolean,
  requestEmailFile: File | null
): boolean {
  if (!form.customer_id && !form.customer_name) return false;
  if (!form.project_name) return false;
  if (!form.work_type) return false;
  if (form.work_request.length === 0) return false;
  if (requiresResearch && (form.impacted_parcels === '' || Number(form.impacted_parcels) < 0))
    return false;
  if (requiresBasic && !requestEmailFile) return false;
  return true;
}

// Get initial form state
export function getInitialFormState(): ProjectIntakeForm {
  return {
    customer_id: undefined,
    customer_name: '',
    project_name: '',
    funding_type: 'On-Call',
    work_type: '',
    work_request: [],
    impacted_parcels: '',
    research_is_government_owned: 'No',
    acquisition_is_government_owned: 'No',
    qa_has_documentation: 'No',
    comments_notes: '',
  };
}

// Reset form to initial state
export function resetForm(): ProjectIntakeForm {
  return {
    customer_id: undefined,
    customer_name: '',
    project_name: '',
    funding_type: 'On-Call',
    work_type: '',
    work_request: [],
    impacted_parcels: '',
    research_is_government_owned: 'Yes',
    acquisition_is_government_owned: 'Yes',
    qa_has_documentation: 'Yes',
    comments_notes: '',
  };
}
